/** Debe coincidir con `NeoBannerDTO.TIPO_ALIADO_ESTRATEGICO`. */
export const ALIANZA_BANNER_TIPO = 'Estrategico';

/** Autoplay hub y landing cuando hay 2+ alianzas. */
export const ALIANZA_CARRUSEL_MS = 10_000;

/** Duración fade out / fade in al cambiar de alianza (ms). */
export const ALIANZA_CARRUSEL_FADE_MS = 220;
